import { render } from "./CurrentBilling.vue?vue&type=template&id=fda683ba&scoped=true"
import script from "./CurrentBilling.vue?vue&type=script&lang=js"
export * from "./CurrentBilling.vue?vue&type=script&lang=js"

import "ag-grid-community/dist/styles/ag-theme-alpine.css?vue&type=style&index=0&lang=css"
import "ag-grid-community/dist/styles/ag-grid.css?vue&type=style&index=1&lang=css"
import "./CurrentBilling.vue?vue&type=style&index=2&id=fda683ba&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2743156286/src/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fda683ba"]])

export default __exports__